import {
	Autocomplete,
	Box,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	Stack,
	TextField,
} from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import CommonGrid from "../Repository/CommonGrid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import {
	convetCaseDropDown,
	fromExactDropdowns,
} from "../../constants/constantList";
import { PatternControl } from "../ItemProperties/Forms/PatternControl";
import { debounce } from "lodash";
import { treeActions } from "../../redux/slices/treeSlice";

const initialFieldType = [
	{
		TYPE: "ALPHA",
		FILLCHAR: "+",
	},
	{
		TYPE: "DATE",
	},
	{
		TYPE: "FLOAT",
	},
	{
		TYPE: "INTEGER",
	},
]; 
  

const DefaultFieldTypeValues = () => {
	const { t } = useTranslation();
	const parentScreen = useContext(ParentScreenCtx);
	const { leftTree, rightTree } = useSelector((state) => state.treeData[parentScreen]);
	const templateHeader = rightTree.tree.templateHeader;
	const [rowData, setRowData] = useState([]);
	const [gridAPI, setGridAPI] = useState();
	const [selectedDefaultValue, setSelectedDefaultValue] = useState({});
	const [padDirection, setPadDirection] = useState("");
	const [fillCharacter, setFillCharacter] = useState('');
	const [convertCase, setConvertCase] = useState("");
	const [pattern, setPattern] = useState("");
	const [length, setLength] = useState("");
	const [roundValue, setRoundValue] = useState("");
	const [precision, setPrecision] = useState();
    const leftSelectedNode = leftTree.tree.body.selectedNode;
    const dispatch = useDispatch();

	const convertCaseOptions = convetCaseDropDown.map((e, i) => {
		return (
			<MenuItem key={i + e?.value} value={e?.value}>
				{t(e?.text)}
			</MenuItem>
		);
	});

	const padDirectionOptions = fromExactDropdowns.map((e, i) => {
		return (
			<MenuItem key={i + e?.value} value={e?.value}>
				{t(e?.text)}
			</MenuItem>
		);
	});

	let gridOptions = {
		columnDefs: [
			{
				headerName: t("LBL_DEF_FLD_TYPE_VALUES"),
				field: "key",
				editable: false,
				resizable: false,
			},
		],
	};

	const onSelectHandler = (gridOptions) => {
		const selectedRows = gridOptions.api.getSelectedRows();
		setSelectedDefaultValue(selectedRows[0]);
	};

	const handleFieldType = (fieldLevelSubstitutions = []) => {
		if (!gridAPI) return;
		fieldTypeHandler(fieldLevelSubstitutions, 0, gridAPI);
	};

	const fieldTypeHandler = (data = [], selectionIndex, gridAPI) => {
		if (!gridAPI) {
			setRowData([]);
			return;
		}

		const rowData = data?.map((e, i) => {
			const title = t(e?.TYPE);
			return {
				...e,
				key: title,
				id: i,
			};
		});
		gridAPI.setGridOption('rowData', rowData)

		setTimeout(() => {
			gridAPI.forEachNode((node) => {
				if (node?.data?.id === selectionIndex) {
					node.setSelected(true);
					setSelectedDefaultValue(node.data);
					gridAPI.ensureNodeVisible(node);
				}
			});
			if (!rowData?.length) setSelectedDefaultValue({});
		}, 100);
	};

    const fieldChangeHandler = (key, value, bulk) => {
		if (!gridAPI) return;
		const data = [];
		const selectedNode = gridAPI.getSelectedRows()?.[0] || {};
		gridAPI.forEachNode((node) => {
			if (node?.data?.id === selectedNode?.id) {
				if (key) {
					data.push({
						...node?.data,
						[key]: value,
					});
				} else {
					data.push({
						...node?.data,
						...bulk,
					});
				}
			} else data.push(node?.data);
		});
        fieldTypeHandler(data, selectedNode?.id, gridAPI)
		submitChange(data);
	};

    const submitChange = (value) => {
			console.log("FIELDTYPE", value);
		dispatch(
			treeActions.setRightTreeTemplateHeaders({
				screen: parentScreen,
				key: "FIELDTYPE",
				value: getCleanValue(value),
			})
		);
	};

    const getCleanValue = (values = []) => {
		return values.map((e) => {
			if (e?.id) delete e?.id;
			if (e?.key) delete e?.key;
			return e;
		});
	};

	useEffect(() => {
		if (gridAPI && !rightTree.loading) {
			if (templateHeader?.FIELDTYPE) {
				handleFieldType(templateHeader?.FIELDTYPE?.filter( e => e?.TYPE !== "CURRENCY") || []);
			}
			else {
				handleFieldType(initialFieldType);
				// submitChange(initialFieldType);
			}
		}
	}, [rightTree.loading]);

	useEffect(() => {
		setLength(selectedDefaultValue?.LENGTH || '');
		setPadDirection(selectedDefaultValue?.PADDIR || "RIGHT");
		setFillCharacter(selectedDefaultValue?.FILLCHAR || "SPACE");
		setConvertCase(selectedDefaultValue?.CONVERT_CASE || "DO_NOT_CONVERT");
		setPattern(selectedDefaultValue?.PATTERN || "");
		setPrecision(selectedDefaultValue?.PRECISION || "");
		setRoundValue(selectedDefaultValue?.ROUND === "TRUE");
	}, [selectedDefaultValue?.id]);


    const debounceChangeHandler = useCallback(
		debounce(fieldChangeHandler, 400),
		[leftSelectedNode?.key]
	);


	return (
		<Box padding={"10px"}>
			<Box className='div-textBox-action' sx={{ border: "2px" }}>
				<CommonGrid
					rowData={rowData}
					gridOptions={gridOptions}
					containerStyle={{ height: "100% !important" }}
					gridResizable={true}
					getGridAPI={(e, gridRef) => {
						setGridAPI(gridRef.api);
					}}
					gridProps={{
						overlayNoRowsTemplate: "No Data",
						rowSelection: "single",
						onSelectionChanged: onSelectHandler,
					}}
				/>
			</Box>
			<Stack spacing={"15px"} paddingTop={"15px"}>
				<TextField
					// disabled={fieldName === t("SELECT") || !fieldName}
					autoComplete={"off"}
					label={t("LBL_LENGTH")}
					sx={{ width: "100%" }}
					size='small'
					value={length}
					onChange={(e) => {
						const { value } = e.target;
						setLength(value);
                        debounceChangeHandler("LENGTH", value);
					}}
				/>
				<FormControl variant='outlined' className='width-100' size='small'>
					<InputLabel>{t("LBL_PAD_DIR")}</InputLabel>
					<Select
						// disabled={!selectedSubstitution?.hasOwnProperty("id")}
						value={padDirection}
						onChange={(e) => {
							const value = e.target.value;
							setPadDirection(value);
							debounceChangeHandler("PADDIR", value);
						}}
						MenuProps={{
							PaperProps: {
								sx: {
									maxHeight: 200,
								},
							},
						}}
					>
						{padDirectionOptions}
					</Select>
				</FormControl>
				<Autocomplete
					// disabled={!selectedSubstitution?.hasOwnProperty("id")}
					isOptionEqualToValue={(option, value) => true}
					size='small'
					variant='outlined'
					className='width-100'
					options={[{ key: 1, value: "SPACE", label: t("SPACE") }]}
					value={fillCharacter}
					inputValue={fillCharacter}
					onChange={(event, newValue) => {
						setFillCharacter(newValue?.value || "");
						debounceChangeHandler("FILLCHAR", newValue?.value || "");
					}}
					renderInput={(params) => (
						<TextField
							autoComplete={"off"}
							{...params}
							onChange={(event, newValue) => {
								setFillCharacter(event?.target?.value || "");
								debounceChangeHandler(
									"FILLCHAR",
									`${event?.target?.value || ""}`
								);
							}}
							label={t("LBL_FILL_CHAR")}
						/>
					)}
				/>
				<FormControl variant='outlined' className='width-100' size='small'>
					<InputLabel>{t("LBL_CONVERT_CASE")}</InputLabel>
					<Select
						// disabled={!selectedSubstitution?.hasOwnProperty("id")}
						value={convertCase}
						onChange={(e) => {
							const value = e.target.value;
							setConvertCase(value);
							debounceChangeHandler("CONVERT_CASE", value);
						}}
						MenuProps={{
							PaperProps: {
								sx: {
									maxHeight: 200,
								},
							},
						}}
					>
						{convertCaseOptions}
					</Select>
				</FormControl>
				<PatternControl
					inputId='variableDecPattern'
					inputLabel={t("LBL_PATTERN")}
					pattern={pattern}
					setPattern={(val) => {
						setPattern(val);
						debounceChangeHandler("PATTERN", val);
					}}
					noDateChooser={selectedDefaultValue?.TYPE !== "DATE"}
					roundValue={roundValue}
					setRoundValue={setRoundValue}
					precision={precision}
					setPrecision={setPrecision}
					bulkValuesHandler={(valuesObj) => {

						debounceChangeHandler(null, null, {
                            ...valuesObj,
                            ROUND: valuesObj?.ROUND ? "TRUE" : "FALSE"
                        })
					}}
                    disabled={!["DATE", "FLOAT", "INTEGER"]?.includes(selectedDefaultValue?.TYPE)}
				/>
			</Stack>
		</Box>
	);
};

export default DefaultFieldTypeValues;
